export const TRANSLATIONS = {
  de: {
    nav: { shop: "Shop", movement: "Movement", creators: "Creators", social: "Social", bundle: "Kit-Builder", lookbook: "Lookbook", cart: "Warenkorb" },
    announce: "GRATIS VERSAND AB 50 € · FIGHT FOR YOURSELF · JOIN THE CLUB",
    hero: {
      badge: "Neu · Join The Movement",
      line1: "FIGHT",
      line2: "FOR YOUR-",
      line3: "SELF.",
      sub: "Schluss mit Zucker-Crash, Stress-Sturm und 3-Uhr-Nächten. Anti Unhealthy Club bringt dich zurück in deine Balance – laut, bunt und positiv.",
      cta1: "Zum Shop",
      cta2: "Das Movement",
      scroll: "Scroll & smile",
    },
    marquee: "FIGHT FOR YOURSELF · ANTI UNHEALTHY CLUB · BODY · MIND · SOUL · JOIN THE CLUB ·",
    enemiesTitle: "THE TROUBLEMAKERS",
    enemiesSub: "Fünf Störenfriede klauen dir täglich deine Energie. Zeit, sie zu bremsen.",
    manifestoKicker: "THE MANIFESTO",
    manifestoTitle: "LESS UNHEALTHY. MORE YOU.",
    productsKicker: "The Essentials",
    productsTitle: "FIND YOUR BALANCE",
    productsSub: "Drei Formeln für die drei größten Störenfriede. Jede ein Schritt zurück zu dir.",
    viewProduct: "Ansehen",
    addToCart: "In den Warenkorb",
    bundleTitle: "THE TRIO BUNDLE",
    bundleSub: "Alle drei Balance-Formeln. Ein Preis. Volle Routine.",
    bundleCta: "Bundle sichern",
    save: "Spare",
    socialKicker: "Product in Use",
    socialTitle: "ON THE STREET, IN THE STUDIO, AT HOME",
    socialSub: "So sieht das Movement im echten Leben aus. Getaggt von der Crowd.",
    creatorsKicker: "All-About-Artists",
    creatorsTitle: "THE FACES OF THE CLUB",
    creatorsSub: "Keine Werbung. Echte Stories. Creators, die ihre Balance teilen.",
    fights: "Im Gepäck",
    communityKicker: "Join the Club",
    communityTitle: "BECOME PART OF THE CLUB",
    communitySub: "Early Drops, Club-News und 10 % auf deine erste Bestellung.",
    emailPlaceholder: "deine@email.de",
    join: "Beitreten",
    joined: "Willkommen im Club!",
    footerTagline: "Ein Gesundheits-Movement, keine Apotheke.",
    footerRights: "Alle Rechte vorbehalten. *Nahrungsergänzungsmittel ersetzen keine ausgewogene Ernährung.",
    shop: {
      title: "SHOP",
      sub: "Supplements, Merch und Accessoires für deine Balance.",
      all: "Alle",
      supplement: "Supplements",
      merch: "Merch",
      accessory: "Accessoires",
      soldOut: "Sold Out",
      backSoon: "Bald zurück – in Produktion",
      newDrop: "New Drop",
    },
    dropTeaser: {
      kicker: "Merch Drop 01",
      title1: "PROTEST SUITS YOU.",
      title2: "REALLY.",
      sub: "Shirt, Megafon, Banner: Die Club-Uniform für alle, die für sich einstehen. Kein leiser Merch – laut, bunt, unübersehbar.",
      card1Title: "FIGHT TEE × CLUB MEGAFON",
      card1Sub: "Laut sein ist Selfcare.",
      card2Title: "DEMO BANNER",
      card2Sub: "Roll it out. Fight for yourself.",
      cta: "Drop shoppen",
    },
    lookbook: {
      kicker: "Anti Unhealthy Club · Editorial",
      title: "LOOKBOOK",
      edition: "Drop 01 · Herbst 26",
      sub: "Das Movement in Bildern: Beutel, Drop-Pieces und die Crowd. Zum Durchblättern, nicht zum Schönreden.",
      quote: "LOUDER. KINDER. BOLDER.",
      quoteSub: "Selfcare is a revolution.",
      frames: "Frames",
      cta: "Pieces shoppen",
      ctaTitle: "JEDER FRAME IST SHOPPABLE.",
    },
    pdp: {
      back: "Zurück zum Shop",
      benefits: "What it does",
      details: "Details",
      ships: "Versand in 2–4 Tagen · 30 Tage Geld-zurück",
      related: "Goes well with",
      fights: "Focus",
      lowStock: "Nur noch wenige",
      soldOut: "Ausverkauft",
      packaging: "Verpackung",
      jarNote: "Die Dose wird gerade neu produziert und ist aktuell ausverkauft.",
      jarAlt: "Gleiche Formel im Standbodenbeutel sichern",
      soldOutCta: "Ausverkauft – bald zurück",
    },
    cart: { title: "Your Cart", empty: "Dein Warenkorb ist leer.", emptyCta: "Zum Shop", subtotal: "Zwischensumme", shipping: "Versand", free: "Gratis", checkout: "Checkout (Demo)", continue: "Weiter shoppen", remove: "Entfernen", qty: "Menge", demoNote: "Demo-Checkout – es wird keine echte Zahlung ausgelöst.", success: "Order placed! (Demo)", successSub: "Danke, dass du für dich selbst sorgst. Dies ist ein Demo-Shop – es wurde nichts belastet.", place: "Bestellung abschließen (Demo)", name: "Name", address: "Adresse", city: "Stadt", zip: "PLZ", pay: "Zahlungsdetails (Demo)" },
    movement: { title: "THE MOVEMENT", intro: "ANTI UNHEALTHY CLUB ist keine klassische Supplement-Marke. Es ist ein Movement für deine eigene Gesundheit – laut, bunt und positiv.", visionTitle: "THE VISION", vision: "Vom Supplement-Brand zum modernen Health- & Lifestyle-Movement. Wir verbinden Premium-Formeln mit Creator-Kultur, Design, Community und Humor.", ctaShop: "Werde Teil des Clubs" },
    builder: { kicker: "Build your Kit", title: "MIX YOUR CLUB KIT", sub: "Kombiniere Supplements, Merch & Accessoires zu deinem Signature-Set. Je mehr Pieces, desto mehr sparst du.", pick: "Pick your pieces", tierHint: "3 Pieces −10 % · 4 Pieces −15 % · ab 5 Pieces −20 %", yourKit: "Your Kit", empty: "Noch nichts drin. Wähle mind. 3 Pieces für deinen Rabatt.", items: "Pieces", discount: "Rabatt", youSave: "Du sparst", total: "Kit-Preis", addKit: "Kit in den Warenkorb", need3: "Wähle 3+ Pieces", nextTier: "Noch {n} Pieces bis {p} % Rabatt", maxTier: "Maximaler Rabatt erreicht – nice!", kitName: "My Club Kit", share: "Kit-Link teilen", shared: "Link kopiert!", shareHint: "Teile deinen Link – die Crowd shoppt dein Kit gemeinsam.", fromShare: "Von der Crowd geteilt – dein Club-Kit ist geladen", storyBtn: "Story-Card erstellen", storyHint: "Perfekt für Instagram Stories (9:16)", download: "Bild speichern", myKit: "MY CLUB KIT", close: "Schließen", storyTag: "Poste dein Kit & tagge @antiunhealthyclub" },
    drop: { kicker: "Limited Drop", title: "NEXT DROP LOADING", sub: "Die nächste limitierte Merch-Runde landet bald. Nur solange der Vorrat reicht – sei schneller als der Sell-out.", days: "Tage", hours: "Std", mins: "Min", secs: "Sek", cta: "Drop-Reminder sichern", live: "The Drop is LIVE!", reminded: "Reminder aktiv! Wir melden uns." },
    creatorPage: { back: "Alle Creators", story: "The Story", reels: "Reels & Moments", follow: "Folgen", fights: "Im Gepäck", shopFight: "Zum Favoriten", more: "More Creators" },
    manifestoShare: "Statement teilen",
  },
  en: {
    nav: { shop: "Shop", movement: "Movement", creators: "Creators", social: "Social", bundle: "Kit Builder", lookbook: "Lookbook", cart: "Cart" },
    announce: "FREE SHIPPING OVER €50 · FIGHT FOR YOURSELF · JOIN THE CLUB",
    hero: {
      badge: "New · Join The Movement",
      line1: "FIGHT",
      line2: "FOR YOUR-",
      line3: "SELF.",
      sub: "No more sugar crashes, stress storms and 3am nights. Anti Unhealthy Club brings you back to balance — loud, colourful and positive.",
      cta1: "Shop now",
      cta2: "The movement",
      scroll: "Scroll & smile",
    },
    marquee: "FIGHT FOR YOURSELF · ANTI UNHEALTHY CLUB · BODY · MIND · SOUL · JOIN THE CLUB ·",
    enemiesTitle: "THE TROUBLEMAKERS",
    enemiesSub: "Five troublemakers steal your energy every day. Time to slow them down.",
    manifestoKicker: "THE MANIFESTO",
    manifestoTitle: "LESS UNHEALTHY. MORE YOU.",
    productsKicker: "The Essentials",
    productsTitle: "FIND YOUR BALANCE",
    productsSub: "Three formulas for the three biggest troublemakers. Each one a step back to you.",
    viewProduct: "View",
    addToCart: "Add to cart",
    bundleTitle: "THE TRIO BUNDLE",
    bundleSub: "All three balance formulas. One price. Full routine.",
    bundleCta: "Get the bundle",
    save: "Save",
    socialKicker: "Product in Use",
    socialTitle: "ON THE STREET, IN THE STUDIO, AT HOME",
    socialSub: "This is what the movement looks like in real life. Tagged by the crowd.",
    creatorsKicker: "All-About-Artists",
    creatorsTitle: "THE FACES OF THE CLUB",
    creatorsSub: "No ads. Real stories. Creators sharing their balance.",
    fights: "In their bag",
    communityKicker: "Join the Club",
    communityTitle: "BECOME PART OF THE CLUB",
    communitySub: "Early drops, club news and 10% off your first order.",
    emailPlaceholder: "your@email.com",
    join: "Join",
    joined: "Welcome to the club!",
    footerTagline: "A health movement, not a pharmacy.",
    footerRights: "All rights reserved. *Supplements do not replace a balanced diet.",
    shop: {
      title: "SHOP",
      sub: "Supplements, merch and accessories for your balance.",
      all: "All",
      supplement: "Supplements",
      merch: "Merch",
      accessory: "Accessories",
      soldOut: "Sold Out",
      backSoon: "Back soon – in production",
      newDrop: "New Drop",
    },
    dropTeaser: {
      kicker: "Merch Drop 01",
      title1: "PROTEST SUITS YOU.",
      title2: "REALLY.",
      sub: "Tee, megaphone, banner: the club uniform for everyone who stands up for themselves. No quiet merch — loud, colourful, unmissable.",
      card1Title: "FIGHT TEE × CLUB MEGAPHONE",
      card1Sub: "Being loud is selfcare.",
      card2Title: "DEMO BANNER",
      card2Sub: "Roll it out. Fight for yourself.",
      cta: "Shop the drop",
    },
    lookbook: {
      kicker: "Anti Unhealthy Club · Editorial",
      title: "LOOKBOOK",
      edition: "Drop 01 · Autumn 26",
      sub: "The movement in pictures: pouches, drop pieces and the crowd. Made for browsing, not for bragging.",
      quote: "LOUDER. KINDER. BOLDER.",
      quoteSub: "Selfcare is a revolution.",
      frames: "Frames",
      cta: "Shop the pieces",
      ctaTitle: "EVERY FRAME IS SHOPPABLE.",
    },
    pdp: {
      back: "Back to shop",
      benefits: "What it does",
      details: "Details",
      ships: "Ships in 2–4 days · 30-day money back",
      related: "Goes well with",
      fights: "Focus",
      lowStock: "Only a few left",
      soldOut: "Sold out",
      packaging: "Packaging",
      jarNote: "The jar is currently being reproduced and is sold out.",
      jarAlt: "Get the same formula in the stand-up pouch",
      soldOutCta: "Sold out – back soon",
    },
    cart: { title: "Your cart", empty: "Your cart is empty.", emptyCta: "Go to shop", subtotal: "Subtotal", shipping: "Shipping", free: "Free", checkout: "Checkout (Demo)", continue: "Continue shopping", remove: "Remove", qty: "Qty", demoNote: "Demo checkout — no real payment is processed.", success: "Order placed! (Demo)", successSub: "Thanks for taking care of yourself. This is a demo shop — nothing was charged.", place: "Place order (Demo)", name: "Name", address: "Address", city: "City", zip: "ZIP", pay: "Payment details (Demo)" },
    movement: { title: "THE MOVEMENT", intro: "ANTI UNHEALTHY CLUB isn't a classic supplement brand. It's a movement for your own health — loud, colourful and positive.", visionTitle: "THE VISION", vision: "From supplement brand to a modern health & lifestyle movement. We merge premium formulas with creator culture, design, community and humour.", ctaShop: "Join the club" },
    builder: { kicker: "Build your kit", title: "MIX YOUR CLUB KIT", sub: "Combine supplements, merch & accessories into your signature set. The more pieces, the more you save.", pick: "Pick your pieces", tierHint: "3 pieces −10% · 4 pieces −15% · 5+ pieces −20%", yourKit: "Your kit", empty: "Nothing in here yet. Pick at least 3 pieces for your discount.", items: "pieces", discount: "Discount", youSave: "You save", total: "Kit price", addKit: "Add kit to cart", need3: "Pick 3+ pieces", nextTier: "{n} more piece(s) for {p}% off", maxTier: "Max discount unlocked — nice!", kitName: "My Club Kit", share: "Share kit link", shared: "Link copied!", shareHint: "Share your link — the crowd shops your kit together.", fromShare: "Shared by the crowd — your Club Kit is loaded", storyBtn: "Create story card", storyHint: "Perfect for Instagram Stories (9:16)", download: "Save image", myKit: "MY CLUB KIT", close: "Close", storyTag: "Post your kit & tag @antiunhealthyclub" },
    drop: { kicker: "Limited Drop", title: "NEXT DROP LOADING", sub: "The next limited merch drop lands soon. While stocks last — be faster than the sell-out.", days: "days", hours: "hrs", mins: "min", secs: "sec", cta: "Get drop reminder", live: "The drop is LIVE!", reminded: "Reminder set! We'll be in touch." },
    creatorPage: { back: "All creators", story: "The story", reels: "Reels & moments", follow: "Follow", fights: "In their bag", shopFight: "Shop their favourite", more: "More creators" },
    manifestoShare: "Share the statement",
  },
};
